import React from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { Button, Card, Spinner } from 'react-bootstrap';
import styles from '../../../styles.module.css';
import { getPrefix } from '../../../util/utils';
import history from '../../../services/history';
import { fetchStressByCod } from '../../../services/stress';
import LaudoCardHeader from '../../../components/laudos/LaudoCardHeader';

export default function ReportStress() {
  const { id } = useParams();
  const codLaudo = Number(id);
  const { data: stress, error, isLoading } = useSWR(
    Number.isFinite(codLaudo) && codLaudo > 0 ? `stress-${codLaudo}` : null,
    () => fetchStressByCod(codLaudo)
  );

  const handleGoBack = () => history.goBack();

  if (isLoading || error || !stress) {
    return (
      <Card className="mt-2">
        <LaudoCardHeader title="ECOCARDIOGRAMA DE ESTRESSE" />
        {isLoading && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: '80vh' }}
          >
            <Spinner animation="border" variant="dark" size="lg" />
          </div>
        )}
        {!isLoading && (
          <>
            <span className="text-danger text-center d-block mt-2">
              {error
                ? 'Erro ao carregar laudo de estresse! Tente novamente.'
                : 'Laudo não encontrado.'}
            </span>
            <Card.Footer className="text-muted text-center">
              <Button
                variant="warning"
                onClick={handleGoBack}
                aria-label="Voltar"
              >
                Voltar
              </Button>
            </Card.Footer>
          </>
        )}
      </Card>
    );
  }

  return (
    <Card className="mt-2 mb-2">
      <LaudoCardHeader title="ECOCARDIOGRAMA DE ESTRESSE" />
      <Card.Body>
        <strong className="mr-auto">Nome do Paciente: </strong>
        {`${stress.CODPAC} - ${stress.NOMEPAC}`}
        <br />
        <strong className="mr-auto">Data de Nasc: </strong>
        {`${stress.dataNasc}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong className="mr-auto">Sexo: </strong>
        {`${stress.SEXOPAC}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong className="mr-auto">Idade: </strong>
        {`${stress.idadePAC} anos`}
        <br />
        <strong className="mr-auto">Convênio: </strong>
        {stress.SIGLACONV}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong className="mr-auto">Código: </strong>
        {stress.CODSTRESS}&nbsp;&nbsp;&nbsp;
        <strong className="mr-auto">Data do Stress: </strong>
        {stress.dataStress}
        <br />
        <strong className="mr-auto">
          Médico que Solicitou: {getPrefix(stress.CODSOLICITANTE)}{' '}
        </strong>
        {`${stress.Solicitou}`}
        <hr />
        <div id="isquemia" className="mb-2" style={{ fontSize: 17 }}>
          <div className={styles.preContent}>{stress.ISQUEMIA}</div>
        </div>
        <Card className="text-center">
          <Card.Body>
            <div className={styles.signatureReport}>
              <i className="mr-auto">
                Conferido e assinado eletronicamente por:{' '}
                <strong className="mr-auto">
                  {getPrefix(stress.CODREALIZOU)} {stress.Realizou}
                </strong>
              </i>
              <br />
              <i>Assinatura Digital: {stress.HASH}</i>
            </div>
          </Card.Body>
        </Card>
      </Card.Body>
      <Card.Footer className="text-muted text-center">
        <Button variant="warning" onClick={handleGoBack} aria-label="Voltar">
          Voltar
        </Button>
      </Card.Footer>
    </Card>
  );
}
